import type { OrganizationNotificationType } from 'ab-enums/organizationNotificationType.enum';

import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/timeSettings/update${`?type=${OrganizationNotificationType}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/timeSettings/update`;

export const URL = (type: OrganizationNotificationType): RouteDefinition => `${baseRoute}/timeSettings/update?type=${type}`;
